import type { ComparisonDetail } from "../../../shared/contracts/product-pages.js";

export function openRivalRematch(detail: ComparisonDetail): void {
  const source = detail.sources
    .filter((item) => item.state === "completed")
    .sort((a, b) =>
      (b.effectiveAt ?? "").localeCompare(a.effectiveAt ?? ""),
    )[0];
  if (!source) return;
  window.history.pushState(
    null,
    "",
    `/tee-off?rematch=${encodeURIComponent(source.roundId)}&relation=${encodeURIComponent(detail.relation.id)}`,
  );
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0 });
}
